import Anchor from './Anchor'
import BottomSheet from './BottomSheet'
import BufferList from './BufferList'
import Button from './Button'
import CirclePlaceholder from './CirclePlaceholder'
import Container from './Container'
import Dropdown from './Dropdown'
import Icon from './Icon'
import Image from './Image'
import Input from './Input'
import LinePlaceholder from './LinePlaceholder'
import Markdown from './Markdown'
import Modal from './Modal'
import Progress from './Progress'
import Text from './Text'

const primitives = {
    Anchor,
    BottomSheet,
    BufferList,
    Button,
    CirclePlaceholder,
    Container,
    Dropdown,
    Icon,
    Image,
    Input,
    LinePlaceholder,
    Markdown,
    Modal,
    Progress,
    Text,
}

export {
    primitives,

    Anchor,
    BottomSheet,
    BufferList,
    Button,
    CirclePlaceholder,
    Container,
    Dropdown,
    Icon,
    Image,
    Input,
    LinePlaceholder,
    Markdown,
    Modal,
    Progress,
    Text,
}
